import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "../components/ui";
import { FaTimesCircle } from "react-icons/fa";

export default function Cancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-bg p-4">
      <Card className="max-w-md w-full text-center">
        <CardBody className="py-10 px-8">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "rgba(239,68,68,0.1)" }}
          >
            <FaTimesCircle size={32} className="text-red-500" />
          </div>

          <h1 className="text-2xl font-bold text-ink-primary mb-2">Payment Cancelled</h1>
          <p className="text-ink-muted mb-8">
            Your payment was not completed. No charges have been made to your account.
          </p>

          <div className="flex flex-col gap-3">
            <button
              className="btn-primary w-full"
              onClick={() => navigate("/pricing")}
            >
              Try Again
            </button>
            <button
              className="btn-secondary w-full"
              onClick={() => navigate("/dashboard")}
            >
              Go to Dashboard
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
